import dispatcher from "../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "./../HttpRequests/HttpRequest";
import Import_constants from "../Constants/ImportConstants";

class Import_Actions {
  getImportTypes() {
    httpRequest(
      config.webServiceURL + "/Import/GetImportTypes",
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Import_constants.GET_IMPORT_TYPE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Import_constants.GET_IMPORT_TYPE_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getImportConfig(importId) {
    httpRequest(
      config.webServiceURL + "/Import/GetImportConfiguration/" + importId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Import_constants.GET_IMPORT_CONFIG_ON_ID_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Import_constants.GET_IMPORT_CONFIG_ON_ID_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  getTemplate(TemplateModel) {
    httpRequest(
      config.webServiceURL + "/Import/GetTemplate",
      "POST",
      JSON.stringify({
        ...TemplateModel,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Import_constants.GET_IMPORT_TEMPLATE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Import_constants.GET_IMPORT_TEMPLATE_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  uploadData(DataObj) {
    httpRequest(
      config.webServiceURL + "/Import/ImportData",
      "POST",
      JSON.stringify({
        ImportType: DataObj.ImportType,
        EquipmentGroupId: DataObj.EquipmentGroupId,
        WerkId: DataObj.WerkId,
        ImportFile: DataObj.ImportFile,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: Import_constants.UPLOAD_TEMPLATE_DATA_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: Import_constants.UPLOAD_TEMPLATE_DATA_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}

export default new Import_Actions();
